import { render, staticRenderFns } from "./UserExtractRecord.vue?vue&type=template&id=13bb331e&scoped=true&"
import script from "./UserExtractRecord.vue?vue&type=script&lang=js&"
export * from "./UserExtractRecord.vue?vue&type=script&lang=js&"
import style0 from "./UserExtractRecord.vue?vue&type=style&index=0&id=13bb331e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb331e",
  null
  
)

export default component.exports